/* itslucydoodles - animations and the live name-print preview.
   Everything here is switched on/off in Customise > Theme settings > Lucy · Animations & doodles. */

(function () {
  if (window.lucyDoodlesInit) return;
  window.lucyDoodlesInit = true;

  var body = document.body;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- Scroll reveals ---------- */
  var REVEAL = [
    ['.lucy-hero__text', 'up'],
    ['.lucy-hero__stack', 'tilt'],
    ['.lucy-sticker', 'pop'],
    ['.lucy-imgtext__media', 'tilt'],
    ['.lucy-imgtext__text', 'up'],
    ['.lucy-name__text', 'up'],
    ['.lucy-name__frame', 'tilt'],
    ['.lucy-badge', 'pop'],
    ['.lucy-reviews__intro', 'up'],
    ['.lucy-review', 'pop'],
    ['.lucy-insta__top', 'up'],
    ['.lucy-insta__grid > li', 'pop'],
    ['.lucy-colbanner__box', 'up'],
    ['.lucy-footer__col', 'up'],
    ['.lucy-divider', 'up'],
    ['.lucy-footer__peek', 'peek'],
    ['.lucy-pbanner__text', 'up'],
    ['.lucy-pbanner__art', 'tilt'],
    ['.lucy-blog__item', 'pop'],
    ['.lucy-jokes__top', 'up'],
    ['.lucy-jokes__grid > li', 'pop'],
    ['.lucy-cards__top', 'up'],
    ['.lucy-card', 'pop'],
    ['.lucy-article__image', 'tilt'],
    ['.lucy-article__signoff', 'up'],
    ['.lucy-article__note', 'up']
  ];

  function observeAll(root) {
    if (reduceMotion || designMode || !body.classList.contains('lucy-anim-reveal')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });

    REVEAL.forEach(function (pair) {
      var groups = new Map();
      (root || document).querySelectorAll(pair[0]).forEach(function (el) {
        if (el.classList.contains('lucy-reveal')) return;
        var parent = el.parentElement;
        var i = groups.get(parent) || 0;
        groups.set(parent, i + 1);
        el.classList.add('lucy-reveal', 'lucy-reveal--' + pair[1]);
        el.style.setProperty('--lucy-delay', Math.min(i, 6) * 90 + 'ms');
        io.observe(el);
      });
    });
  }

  /* ---------- Hand-lettered words stamp in ---------- */
  function letterPop(root) {
    if (reduceMotion || designMode || !body.classList.contains('lucy-anim-letters')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lucy-letters-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    (root || document).querySelectorAll('h1, h2, h3').forEach(function (h) {
      if (!h.querySelector('em') || h.classList.contains('lucy-letters')) return;
      h.classList.add('lucy-letters');
      h.querySelectorAll('em').forEach(function (em, i) {
        em.style.setProperty('--lucy-delay', 150 + i * 140 + 'ms');
      });
      io.observe(h);
    });
  }

  /* ---------- Calm mode: pause every moving doodle for this visitor ---------- */
  var ANIM_CLASSES = ['lucy-anim-reveal', 'lucy-anim-letters', 'lucy-anim-doodles'];
  var savedClasses = ANIM_CLASSES.filter(function (c) { return body.classList.contains(c); });
  function readCalm() {
    try { return window.localStorage.getItem('lucyCalm') === '1'; } catch (e) { return false; }
  }
  function setCalm(on, remember) {
    document.documentElement.classList.toggle('lucy-calm-on', on);
    savedClasses.forEach(function (c) { body.classList.toggle(c, !on); });
    document.querySelectorAll('[data-lucy-calm]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (remember) {
      try { window.localStorage.setItem('lucyCalm', on ? '1' : '0'); } catch (e) { /* storage blocked: still works for this page */ }
    }
  }
  if (readCalm()) setCalm(true, false);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lucy-calm]');
    if (!btn) return;
    setCalm(btn.getAttribute('aria-pressed') !== 'true', true);
  });

  /* ---------- Giggle corner: flip a joke card ---------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-lucy-joke]');
    if (!card) return;
    var open = card.getAttribute('aria-expanded') === 'true';
    var answer = card.querySelector('[data-answer]');
    card.setAttribute('aria-expanded', open ? 'false' : 'true');
    card.classList.toggle('is-flipped', !open);
    if (answer) answer.textContent = open ? '' : answer.getAttribute('data-answer');
  });

  function init(root) {
    if (readCalm()) setCalm(true, false);
    observeAll(root);
    letterPop(root);
    document.querySelectorAll('[data-lucy-calm]').forEach(function (b) {
      b.setAttribute('aria-pressed', document.documentElement.classList.contains('lucy-calm-on') ? 'true' : 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- Live name-print preview ("Lucy · Name print preview" section) ---------- */
if (!customElements.get('lucy-name-preview')) {
  class LucyNamePreview extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="text"]');
      this.letters = this.querySelector('[data-letters]');
      this.print = this.querySelector('[data-print]');
      this.colours = ['#ffd45c', '#9bd67a', '#7cc7e8', '#f59ac0', '#b58be0'];
      this.lastLength = 0;
      if (!this.input || !this.letters) return;
      this.input.addEventListener('input', () => this.render(true));
      this.querySelectorAll('[data-swatch]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-swatch]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          if (this.print) this.print.style.background = button.dataset.swatch;
        });
      });
      this.render(false);
    }

    render(typed) {
      const typedName = (this.input.value || '').trim();
      const name = typedName || this.input.getAttribute('placeholder') || 'Name';
      const chars = Array.from(name.slice(0, 14));
      this.letters.textContent = '';
      chars.forEach((ch, i) => {
        const span = document.createElement('span');
        span.textContent = ch === ' ' ? ' ' : ch;
        span.style.background = this.colours[i % this.colours.length];
        span.style.setProperty('--lucy-rot', (i % 2 ? 3 : -3) + 'deg');
        span.style.transform = 'rotate(var(--lucy-rot))';
        if (typed && typedName && i === chars.length - 1 && chars.length > this.lastLength) span.classList.add('is-new');
        this.letters.appendChild(span);
      });
      this.lastLength = typedName ? chars.length : 0;
    }
  }
  customElements.define('lucy-name-preview', LucyNamePreview);
}
